import { render, staticRenderFns } from "./vRecipeListing.vue?vue&type=template&id=c931f130&scoped=true"
import script from "./vRecipeListing.vue?vue&type=script&lang=ts"
export * from "./vRecipeListing.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeListing.vue?vue&type=style&index=0&id=c931f130&prod&lang=css&scoped=true"
import style1 from "./vRecipeListing.vue?vue&type=style&index=1&id=c931f130&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c931f130",
  null
  
)

export default component.exports